<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới tài khoản đơn vị đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="save" v-if="authorize(['ManageSyncUser'])">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitLevelFeedback"
                                                  v-model="$v.syncUser.syncDataSourceId.$model"
                                                  :state="$v.syncUser.syncDataSourceId.$dirty ? !$v.syncUser.syncDataSourceId.$error : null"></b-form-input>
                                    <sync-data-source v-model="syncUser.syncDataSourceId"></sync-data-source>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn phần mềm đồng bộ
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị công tác:"
                                              label-for="unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitFeedback"
                                                  v-model="$v.syncUser.unitId.$model"
                                                  :state="$v.syncUser.unitId.$error ? false : null"></b-form-input>
                                    <unit-tree v-model="$v.syncUser.unitId.$model" ref="unitTree"
                                               aria-describedby="unitFeedback"
                                               :state="$v.syncUser.unitId.$dirty? !$v.syncUser.unitId.$error : null"></unit-tree>
                                    <b-form-invalid-feedback id="unitFeedback">
                                        Vui lòng chọn đơn vị
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="userName"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" id="userName"
                                                  aria-describedby="userNameFeedback"
                                                  v-model="$v.syncUser.userName.$model"
                                                  :state="($v.syncUser.userName.$dirty? !$v.syncUser.userName.$error : null) && ($v.nameUnique.$dirty? !$v.nameUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.userName.required">
                                        Vui lòng nhập tên tài khoản
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.userName.usernamePattern">
                                        Tên tài khoản chỉ được phép sử dụng chữ cái và số. Dấu chấm(.) và dấu gạch ngang (-) dùng để phân cách
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.userName.$error && ($v.nameUnique.$error)">
                                        Tên tài khoản đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mật khẩu:"
                                              label-for="password"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="password" id="password"
                                                  aria-describedby="passwordFeedback"
                                                  v-model="$v.syncUser.passwordHash.$model"
                                                  @input="$v.syncUser.passwordHash.$touch"
                                                  :state="$v.syncUser.passwordHash.$dirty? !$v.syncUser.passwordHash.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.passwordHash.required">
                                        Vùi lòng nhập mật khẩu
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.passwordHash.minLength">
                                        Mật khẩu phải có ít nhất 8 ký tự
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="$v.syncUser.passwordHash.minLength && !$v.syncUser.passwordHash.passwordPattern">
                                        Mật khẩu phải chứa chữ hoa, chữ thường, số và ký tự đặc biệt
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nhập lại mật khẩu:"
                                              label-for="passwordConfirmation"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="password" id="passwordConfirmation"
                                                  aria-describedby="passwordConfirmationFeedback"
                                                  v-model="$v.syncUser.passwordConfirmation.$model"
                                                  @input="$v.syncUser.passwordConfirmation.$touch"
                                                  :state="$v.syncUser.passwordConfirmation.$dirty? !$v.syncUser.passwordConfirmation.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.syncUser.passwordConfirmation.required">
                                        Vui lòng nhập lại mật khẩu
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="$v.syncUser.passwordConfirmation.required && !$v.syncUser.passwordConfirmation.sameAsPassword">
                                        Mật khẩu không khớp
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Nhóm tài khoản:"
                                              label-for="roles"
                                              :label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="">
                                    <b-form-checkbox-group v-model="syncUser.roleIds" class="checkbox-group">
                                        <b-form-checkbox v-for="(role, index) in listRoles" :key="role.id" :value="role.id" v-bind:style="{ width: index % 2 == 0 ? 61.5 + '%' : 'auto'}">{{ role.text }}</b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="text-center">
                            <b-button type="submit" variant="primary">Lưu</b-button>
                            <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const passwordPattern = helpers.regex('passwordPattern', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/)
    const usernamePattern = helpers.regex('usernamePattern', /^[a-zA-Z0-9]+([-.]?[a-zA-Z0-9])*$/)

    export default {
        name: 'CreateCountry',
        mixins: [validationMixin, mixins],
        data() {
            return {
                nameUnique: 'ok',
                listRoles: [],
                syncUser: {
                    syncDataSourceId: null,
                    userName: null,
                    name: null,
                    passwordHash: null,
                    unitId: null,
                    passwordConfirmation: null,
                    phoneNumber: null
                },
                editing: false
            }
        },
        computed: {
            ...mapState({
                units: (state, getters) => getters.unitTree,
                privileges: (state, getters) => state.identity.privileges
            })
        },
        validations: {
            syncUser: {
                syncDataSourceId: { required },
                userName: {
                    required,
                    usernamePattern
                },
                unitId: { required },
                passwordHash: { required, minLength: minLength(8), passwordPattern },
                passwordConfirmation: { required, sameAsPassword: sameAs('passwordHash') },
            },
            nameUnique: { required }
        },
        created() {
            var vm = this;
            this.$services.get('lookup/sync-roles').done((response) => vm.listRoles = response);
        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.syncUser.userName) {
                    vm.$services.get(`sync-users/existing-user-name?name=${vm.syncUser.userName || ''}`).done(returnData => {
                        if (!returnData) {
                            vm.nameUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.post('sync-users', vm.syncUser).done((id) => {
                                    vm.$toastr.s('Tạo mới tài khoản thành công');
                                    vm.cancel();
                                });
                            }
                        }
                        else {
                            vm.nameUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .mgt-10 {
        margin-top: 8px;
    }
</style>
